import Controller from '@ember/controller';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Settings from 'donor-elf-web/services/settings';

export default class GoalTotalAndExpectingController extends Controller {
  @service declare router: RouterService;
  @service declare settings: Settings;

  @tracked saving = false;
  @tracked showValidationErrors = false;
  @tracked error: any;

  @action
  templateWillDestroy() {
    this.saving = false;
    this.showValidationErrors = false;
    this.error = undefined;
  }

  @action
  async save() {
    if (this.saving) {
      return;
    }
    this.saving = true;

    let changeset = this.model.changeset;
    await changeset.validate();
    this.showValidationErrors = true;
    if (changeset.get('isValid')) {
      try {
        await changeset.save();
        this.router.transitionTo('funds.fund.dashboard');
      } catch (error) {
        this.error = error;
        this.saving = false;
      }
    }
  }
}
